module.exports = __webpack_public_path__ + "9967288860a3730dd0c1287981ead0fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Policy/home-slide-1.jpg
// module id = 1918
// module chunks = 0